/**
 * Adds a new toast message in the UI Frame.
 * @param {string} message The message of the toast.
 * @param {'success'|'info'|'error'} messageType The type of the toast.
 * @param {string} [link] This could be used to pass an URL to the toast message.
 * @param {EventTarget} [target] The EventTarget on which the event should be dispatched.
 */
export function addToast(message, messageType, link = null, target = window) {
    target.dispatchEvent(new CustomEvent('synapse-app-event', {
        detail: {
            type: 'add-toast',
            message,
            messageType,
            link,
            exposed: true,
        },
        bubbles: true,
        composed: true,
    }));
}
/**
 * Reset toast messages in the UI Frame.
 * @param {EventTarget} [target] The EventTarget on which the event should be dispatched.
 */
export function resetToasts(target = window) {
    target.dispatchEvent(new CustomEvent('synapse-app-event', {
        detail: {
            type: 'reset-toasts',
            exposed: true,
        },
        bubbles: true,
        composed: true,
    }));
}
